import { Box } from "@mui/material";
import { ReactNode } from "react";

interface ImpressumRootFrameProps {
    children: ReactNode;
    constrainToViewport?: boolean;
}

export default function ImpressumRootFrame({
    children,
    constrainToViewport = false,
}: ImpressumRootFrameProps) {
    return (
        <Box
            sx={{
                px: '10%',
                py: 8,
                ...(constrainToViewport && {
                    boxSizing: 'border-box',
                    display: 'flex',
                    height: 'calc(100dvh - var(--header-height, 0px))',
                    maxHeight: 'calc(100dvh - var(--header-height, 0px))',
                    minHeight: 0,
                    minWidth: 0,
                    overflow: 'hidden',
                    width: '100%',
                }),
            }}
        >
            {children}
        </Box>
    );
}
